import { Address } from '@/models/common/address';

export class ContactDetails {
    public name?: string;
    public phone?: string;
    public phoneTwo?: string;
    public email?: string;
    public address: Address = new Address();

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, { address: json.address ? new Address(json.address) : new Address() });
    }

    public clone(): ContactDetails {
        const contactDetails: ContactDetails = new ContactDetails();

        contactDetails.name = this.name;
        contactDetails.phone = this.phone;
        contactDetails.phoneTwo = this.phoneTwo;
        contactDetails.email = this.email;
        contactDetails.address = this.address.clone();

        return contactDetails;
    }
}
